import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  updatePrivacy,
  getStoryArchiveSetting,
  updateStoryArchiveSetting,
} from "../../../functions/user";
import PersonalDetails from "./PersonalDetails";
import "../style.css";
import "./SettingsPrivacy.css";

// Modern Icons as SVG Components
const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const FileTextIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14,2 14,8 20,8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10,9 9,9 8,9"/>
  </svg>
);

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <circle cx="12" cy="16" r="1"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const BellIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
);

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const PostsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
    <line x1="12" y1="8" x2="18" y2="8" strokeWidth="2"/>
    <line x1="12" y1="12" x2="18" y2="12" strokeWidth="1.5"/>
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

const GroupIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const FriendsExceptIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    <line x1="18" y1="6" x2="24" y2="0" strokeWidth="2.5"/>
  </svg>
);


const PersonalDetailsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="4" y="4" width="16" height="20" rx="2" ry="2"/>
    <circle cx="12" cy="10" r="2"/>
    <line x1="8" y1="16" x2="16" y2="16" strokeWidth="2"/>
    <line x1="8" y1="19" x2="16" y2="19" strokeWidth="2"/>
  </svg>
);

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";


export default function SettingsPrivacy({ setVisible }) {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state);
  const [showPersonalDetails, setShowPersonalDetails] = useState(false);
  const [privacy, setPrivacy] = useState(() => {
    return localStorage.getItem("accountPrivacy") || "public";
  });

  useEffect(() => {
    localStorage.setItem("accountPrivacy", privacy);
  }, [privacy]);

  const handlePrivacyChange = async (e) => {
    const newPrivacy = e.target.value;
    setPrivacy(newPrivacy);
    localStorage.setItem("accountPrivacy", newPrivacy);
    
    // Sync post visibility with account privacy
    setPostVisibility(newPrivacy);
    localStorage.setItem("postVisibility", newPrivacy);
    
    if (user && user.token) {
      await updatePrivacy(newPrivacy, user.token);
      // Update post visibility on the server if needed
      try {
        // await axios.post(`${API_URL}/api/user/postVisibility`, { visibility: newPrivacy }, {
        //   headers: { Authorization: `Bearer ${user.token}` },
        // });
      } catch (err) {
        console.error("Failed to update post visibility:", err);
      }
    }
  };

  // Blocked users state
  const [blockedUsers, setBlockedUsers] = useState([]);
  useEffect(() => {
    const fetchBlockedUsers = async () => {
      if (user && user.token) {
        try {
          const res = await axios.get(`${API_URL}/api/block/blockedUsers`, {
            headers: { Authorization: `Bearer ${user.token}` },
          });
          setBlockedUsers(res.data.blockedUsers || []);
        } catch (err) {
          setBlockedUsers([]);
        }
      }
    };
    fetchBlockedUsers();
  }, [user]);

  // Posts privacy settings state - initialize with account privacy if available, otherwise use saved post visibility or default to 'friends'
  const [postVisibility, setPostVisibility] = useState(() => {
    const accountPrivacy = localStorage.getItem("accountPrivacy");
    return accountPrivacy || localStorage.getItem("postVisibility") || "friends";
  });
  const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
    const stored = localStorage.getItem("notificationsEnabled");
    return stored !== null ? stored === "true" : true;
  });
  const [showAudienceModal, setShowAudienceModal] = useState(false);
  const [saveStoriesToArchive, setSaveStoriesToArchive] = useState(() => {
    const stored = localStorage.getItem("saveStoriesToArchive");
    return stored !== null ? stored === "true" : true;
  });
  const [selectedAudience, setSelectedAudience] = useState(() => {
    return localStorage.getItem("postVisibility") || "friends";
  });
  const [showLimitPastPostsModal, setShowLimitPastPostsModal] = useState(false);
  const [showLimitPastPostsConfirmModal, setShowLimitPastPostsConfirmModal] = useState(false);

  const handlePostVisibilityChange = () => {
    const isMobileViewport = typeof window !== "undefined" && window.innerWidth <= 768;
    if (isMobileViewport) {
      navigate("/settings/audience", {
        state: { from: "/settings" },
      });
      return;
    }
    setSelectedAudience(postVisibility);
    setShowAudienceModal(true);
  };

  const handleAudienceSelect = (audience) => {
    setSelectedAudience(audience);
  };

  const handleAudienceSave = async () => {
    setPostVisibility(selectedAudience);
    localStorage.setItem("postVisibility", selectedAudience);
    setShowAudienceModal(false);
    if (user && user.token) {
      try {
        // API call to save post visibility would go here
        // await axios.post(`${API_URL}/api/user/postVisibility`, { visibility: selectedAudience }, {
        //   headers: { Authorization: `Bearer ${user.token}` },
        // });
      } catch (err) {
        console.error("Failed to update post visibility:", err);
      }
    }
  };

  const handleAudienceCancel = () => {
    setSelectedAudience(postVisibility);
    setShowAudienceModal(false);
  };


  const handleConfirmLimitPastPosts = () => {
    setShowLimitPastPostsModal(false);
    setShowLimitPastPostsConfirmModal(true);
  };

  const handleCancelLimitPastPosts = () => {
    setShowLimitPastPostsModal(false);
  };

  const handleFinalConfirmLimitPastPosts = async () => {
    if (user && user.token) {
      try {
        // API call to limit past posts would go here
        // await axios.post(`${API_URL}/api/user/limitPastPosts`, {}, {
        //   headers: { Authorization: `Bearer ${user.token}` },
        // });
        localStorage.setItem("pastPostsLimited", "true");
        setShowLimitPastPostsConfirmModal(false);
      } catch (err) {
        console.error("Failed to limit past posts:", err);
        setShowLimitPastPostsConfirmModal(false);
      }
    } else {
      localStorage.setItem("pastPostsLimited", "true");
      setShowLimitPastPostsConfirmModal(false);
    }
  };

  const handleCancelLimitPastPostsConfirm = () => {
    setShowLimitPastPostsConfirmModal(false);
  };

  const handleNotificationsToggle = (e) => {
    const enabled = e.target.checked;
    setNotificationsEnabled(enabled);
    localStorage.setItem("notificationsEnabled", enabled.toString());
    window.dispatchEvent(
      new CustomEvent("notifications-setting-changed", { detail: { enabled } })
    );
  };

  useEffect(() => {
    const fetchStoryArchiveSetting = async () => {
      if (!user?.token) return;
      const response = await getStoryArchiveSetting(user.token);
      if (response?.status === "ok") {
        const enabled = response.saveStoriesToArchive !== false;
        setSaveStoriesToArchive(enabled);
        localStorage.setItem("saveStoriesToArchive", enabled.toString());
      }
    };
    fetchStoryArchiveSetting();
  }, [user?.token]);

  const handleSaveStoriesToArchiveToggle = async (e) => {
    const enabled = e.target.checked;
    setSaveStoriesToArchive(enabled);
    localStorage.setItem("saveStoriesToArchive", enabled.toString());
    if (user?.token) {
      const response = await updateStoryArchiveSetting(enabled, user.token);
      if (response?.status !== "ok") {
        setSaveStoriesToArchive(!enabled);
        localStorage.setItem("saveStoriesToArchive", (!enabled).toString());
      }
    }
  };

  const getVisibilityLabel = (visibility) => {
    const labels = {
      public: "Public",
      friends: "Friends",
      friends_except: "Friends except...",
      specific_friends: "Specific friends",
      only_me: "Only me",
    };
    return labels[visibility] || "Friends";
  };

  // If Personal Details is shown, render that component
  if (showPersonalDetails) {
    return <PersonalDetails setVisible={(val) => {
      if (val === false) {
        setShowPersonalDetails(false);
      } else {
        setVisible && setVisible(val);
      }
    }} />;
  }

return (
  <>
    {/* Go Back Button */}
    <button
      className="settings_back_btn"
      onClick={() => navigate("/")}
      aria-label="Go Back"
    >
      <XIcon />
      <span>Go Back</span>
    </button>
    
    {/* Select Audience Modal */}
    {showAudienceModal && (
      <div className="audience_modal_overlay" onClick={handleAudienceCancel}>
        <div className="audience_modal" onClick={(e) => e.stopPropagation()}>
          <div className="audience_modal_header">
            <h3 className="audience_modal_title">Select audience</h3>
            <button 
              className="audience_modal_close"
              onClick={handleAudienceCancel}
              aria-label="Close"
            >
              <XIcon />
            </button>
          </div>
          
          <div className="audience_modal_content">
            <div className="audience_modal_info">
              <h4 className="audience_modal_heading">Who can see your future posts?</h4>
              <p className="audience_modal_description">
                Your default audience is set to <strong>{getVisibilityLabel(selectedAudience)}</strong>. This will be your audience for future posts, but you can always change it for a specific post.
              </p>
            </div>
            
            <div className="audience_options_list">
              <label 
                className={`audience_option ${selectedAudience === "public" ? "selected" : ""}`}
                onClick={() => handleAudienceSelect("public")}
              >
                <div className="audience_option_icon">
                  <GlobeIcon />
                </div>
                <div className="audience_option_content">
                  <span className="audience_option_label">Public</span>
                  <span className="audience_option_desc">Anyone on or off UsmaApp</span>
                </div>
                <input
                  type="radio"
                  name="audience"
                  value="public"
                  checked={selectedAudience === "public"}
                  onChange={() => handleAudienceSelect("public")}
                />
              </label>

              <label 
                className={`audience_option ${selectedAudience === "friends" ? "selected" : ""}`}
                onClick={() => handleAudienceSelect("friends")}
              >
                <div className="audience_option_icon">
                  <GroupIcon />
                </div>
                <div className="audience_option_content">
                  <span className="audience_option_label">Friends</span>
                  <span className="audience_option_desc">Your friends on UsmaApp</span>
                </div>
                <input
                  type="radio"
                  name="audience"
                  value="friends"
                  checked={selectedAudience === "friends"}
                  onChange={() => handleAudienceSelect("friends")}
                />
              </label>

              <label 
                className={`audience_option ${selectedAudience === "friends_except" ? "selected" : ""}`}
                onClick={() => handleAudienceSelect("friends_except")}
              >
                <div className="audience_option_icon">
                  <FriendsExceptIcon />
                </div>
                <div className="audience_option_content">
                  <span className="audience_option_label">Friends except...</span>
                  <span className="audience_option_desc">Don't show to some friends</span>
                </div>
                <input
                  type="radio"
                  name="audience"
                  value="friends_except"
                  checked={selectedAudience === "friends_except"}
                  onChange={() => handleAudienceSelect("friends_except")}
                />
              </label>

              {/* <label 
                className={`audience_option ${selectedAudience === "specific_friends" ? "selected" : ""}`}
                onClick={() => handleAudienceSelect("specific_friends")}
              >
                <div className="audience_option_icon">
                  <PersonIcon />
                </div>
                <div className="audience_option_content">
                  <span className="audience_option_label">Specific friends</span>
                  <span className="audience_option_desc">Only show to some friends</span>
                </div>
                <input
                  type="radio"
                  name="audience"
                  value="specific_friends"
                  checked={selectedAudience === "specific_friends"}
                  onChange={() => handleAudienceSelect("specific_friends")}
                />
              </label> */}

              <label 
                className={`audience_option ${selectedAudience === "only_me" ? "selected" : ""}`}
                onClick={() => handleAudienceSelect("only_me")}
              >
                <div className="audience_option_icon">
                  <LockIcon />
                </div>
                <div className="audience_option_content">
                  <span className="audience_option_label">Only me</span>
                </div>
                <input
                  type="radio"
                  name="audience"
                  value="only_me"
                  checked={selectedAudience === "only_me"}
                  onChange={() => handleAudienceSelect("only_me")}
                />
              </label>

              {/* <label 
                className={`audience_option ${selectedAudience === "custom" ? "selected" : ""}`}
                onClick={() => handleAudienceSelect("custom")}
              >
                <div className="audience_option_icon">
                  <SettingsIcon />
                </div>
                <div className="audience_option_content">
                  <span className="audience_option_label">Custom</span>
                  <span className="audience_option_desc">Include and exclude friends and lists</span>
                </div>
                <input
                  type="radio"
                  name="audience"
                  value="custom"
                  checked={selectedAudience === "custom"}
                  onChange={() => handleAudienceSelect("custom")}
                />
              </label> */}
            </div>
          </div>
          
          <div className="audience_modal_footer">
            <button className="audience_modal_cancel" onClick={handleAudienceCancel}>
              Cancel
            </button>
            <button className="audience_modal_done" onClick={handleAudienceSave}>
              Done
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Limit Past Posts Modal */}
    {showLimitPastPostsModal && (
      <div className="limit_posts_modal_overlay" onClick={handleCancelLimitPastPosts}>
        <div className="limit_posts_modal" onClick={(e) => e.stopPropagation()}>
          <div className="limit_posts_modal_header">
            <h3 className="limit_posts_modal_title">Limit past posts</h3>
            <button 
              className="limit_posts_modal_close"
              onClick={handleCancelLimitPastPosts}
              aria-label="Close"
            >
              <XIcon />
            </button>
          </div>
          
          <div className="limit_posts_modal_content">
            <h4 className="limit_posts_modal_heading">
              Limit who can see past posts on your timeline
            </h4>
            
            <div className="limit_posts_modal_text">
              <p>
                If you choose to limit your past posts, posts on your timeline that you've shared with Friends of friends, and Public posts, will only be shared with Friends. Anyone tagged in these posts, and their friends, may also still see these posts.
              </p>
              <p>
                If you want to change who can see a specific post, you can go to that post and choose a different audience.
              </p>
            </div>
          </div>
          
          <div className="limit_posts_modal_footer">
            <button 
              className="limit_posts_confirm_btn" 
              onClick={handleConfirmLimitPastPosts}
            >
              Limit past posts
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Limit Past Posts Confirmation Modal */}
    {showLimitPastPostsConfirmModal && (
      <div className="limit_posts_confirm_modal_overlay" onClick={handleCancelLimitPastPostsConfirm}>
        <div className="limit_posts_confirm_modal" onClick={(e) => e.stopPropagation()}>
          <div className="limit_posts_confirm_modal_header">
            <h3 className="limit_posts_confirm_modal_title">Limit all past posts?</h3>
            <button 
              className="limit_posts_confirm_modal_close"
              onClick={handleCancelLimitPastPostsConfirm}
              aria-label="Close"
            >
              <XIcon />
            </button>
          </div>
          
          <div className="limit_posts_confirm_modal_content">
            <p className="limit_posts_confirm_modal_warning">
              You're about to limit all past posts on your timeline. The only way to undo this will be to change the audience of each post one at a time.
            </p>
          </div>
          
          <div className="limit_posts_confirm_modal_footer">
            <button 
              className="limit_posts_confirm_cancel_btn" 
              onClick={handleCancelLimitPastPostsConfirm}
            >
              Cancel
            </button>
            <button 
              className="limit_posts_confirm_final_btn" 
              onClick={handleFinalConfirmLimitPastPosts}
            >
              Limit past posts
            </button>
          </div>
        </div>
      </div>
    )}
    
    <div className="settings_container">
      <div className="settings_header">
        <div className="settings_title_wrapper">
          <ShieldIcon />
          <h2 className="settings_title">
            Settings & Privacy
          </h2>
        </div>
        <p className="settings_subtitle">Manage your account privacy and security settings</p>
      </div>
      
      <div className="settings_content">
        {/* Personal Details Section */}
        <div className="settings_section personal_details_section">
          <button 
            className="personal_details_btn"
            onClick={() => {
              setShowPersonalDetails(true);
            }}
          >
            <div className="personal_details_icon">
              <PersonalDetailsIcon />
            </div>
            <span className="personal_details_text">Personal details</span>
          </button>
        </div>

        {/* Account Privacy Section */}
      <div className="settings_section privacy_section">
        <div className="section_header">
          <div className="section_icon">
            <LockIcon />
          </div>
          <div className="section_title_wrapper">
            <h3 className="section_title">Account Privacy</h3>
            <p className="section_subtitle">Control who can see your profile and posts</p>
          </div>
        </div>
        
        <div className="privacy_controls">
          <div className="privacy_options">
            <label className={`privacy_option ${privacy === "public" ? "active" : ""}`}>
              <input
                type="radio"
                name="privacy"
                value="public"
                checked={privacy === "public"}
                onChange={handlePrivacyChange}
              />
              <div className="option_content">
                <GlobeIcon />
                <div className="option_text">
                  <span className="option_label">Public</span>
                  <span className="option_description">Visible to everyone</span>
                </div>
              </div>
            </label>
            <label className={`privacy_option ${privacy === "private" ? "active" : ""}`}>
              <input
                type="radio"
                name="privacy"
                value="private"
                checked={privacy === "private"}
                onChange={handlePrivacyChange}
              />
              <div className="option_content">
                <LockIcon />
                <div className="option_text">
                  <span className="option_label">Private</span>
                  <span className="option_description">Only approved users</span>
                </div>
              </div>
            </label>
          </div>
          
          <div className="privacy_status">
            <div className="status_indicator">
              <div className={`status_dot ${privacy === "private" ? "private" : "public"}`}></div>
              <span className="status_text">
                {privacy === "public"
                  ? "Your account is visible to everyone."
                  : "Your account is private. Only approved users can view your posts and profile."}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Posts Privacy Section */}
      <div className="settings_section posts_section">
        <div className="section_header">
          <div className="section_icon">
            <PostsIcon />
          </div>
          <div className="section_title_wrapper">
            <h3 className="section_title">Posts</h3>
            <p className="section_subtitle">Control who can see your posts</p>
          </div>
        </div>
        
        <div className="posts_privacy_controls">
          {/* Who can see your future posts */}
          <div className="post_setting_item" onClick={handlePostVisibilityChange}>
            <div className="post_setting_content">
              <h4 className="post_setting_title">Who can see your future posts?</h4>
              <p className="post_setting_current">{getVisibilityLabel(postVisibility)}</p>
            </div>
            <div className="post_setting_chevron">
              <ChevronRightIcon />
            </div>
          </div>

          {/* Limit who can see past posts */}
          {/* <div className="post_setting_item">
            <div className="post_setting_content">
              <h4 className="post_setting_title">Limit who can see past posts</h4>
            </div>
            <button className="limit_past_posts_btn" onClick={handleLimitPastPosts}>
              Limit past posts
            </button>
          </div> */}

          {/* Allow visual search on your posts */}
          {/* <div className="post_setting_item visual_search_item">
            <div className="post_setting_content">
              <h4 className="post_setting_title">Allow visual search on your posts</h4>
              <p className="post_setting_description">
                Visual search finds other content related to your post, to help people discover more of what they're interested in. This is your default, but you can always change it for specific posts.
              </p>
            </div>
            <div className="toggle_switch_container">
              <label className="toggle_switch">
                <input
                  type="checkbox"
                  checked={visualSearchEnabled}
                  onChange={handleVisualSearchToggle}
                />
                <span className="toggle_slider"></span>
              </label>
            </div>
          </div> */}

          <div className="post_setting_item visual_search_item">
            <div className="post_setting_content">
              <h4 className="post_setting_title">Save Stories to Archive</h4>
              <p className="post_setting_description">
                  Save and manage expired stories in archive.
              </p>
            </div>
            <div className="toggle_switch_container">
              <label className="toggle_switch">
                <input
                  type="checkbox"
                  checked={saveStoriesToArchive}
                  onChange={handleSaveStoriesToArchiveToggle}
                />
                <span className="toggle_slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Management Section */}
      <div className="settings_section notifications_section">
        <div className="section_header">
          <div className="section_icon">
            <BellIcon />
          </div>
          <div className="section_title_wrapper">
            <h3 className="section_title">Notification Management</h3>
          </div>
        </div>

        <div className="posts_privacy_controls">
          <div className="post_setting_item notification_management_item">
            <div className="post_setting_content">
              <h4 className="post_setting_title">Notifications</h4>
            </div>
            <div className="toggle_switch_container">
              <label className="toggle_switch notifications_toggle">
                <input
                  className="notifications_toggle_input"
                  type="checkbox"
                  checked={notificationsEnabled}
                  onChange={handleNotificationsToggle}
                />
                <span className="toggle_slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Blocked Users Section */}
      <div className="settings_section blocked_section">
        <div className="section_header">
          <div className="section_icon">
            <UsersIcon />
          </div>
          <div className="section_title_wrapper">
            <h3 className="section_title">Blocked Users</h3>
            <p className="section_subtitle">Manage users you've blocked from contacting you</p>
          </div>
        </div>
        
        {blockedUsers.length === 0 ? (
          <div className="empty_state">
            <div className="empty_icon">
              <UsersIcon />
            </div>
            <div className="empty_content">
              <h4>No blocked users</h4>
              <p>You haven't blocked any users yet. Blocked users will appear here.</p>
            </div>
          </div>
        ) : (
          <div className="blocked_users_container">
            <div className="blocked_count">
              <span className="count_number">{blockedUsers.length}</span>
              <span className="count_label">blocked user{blockedUsers.length !== 1 ? 's' : ''}</span>
            </div>
            <ul className="blocked_users_list">
              {blockedUsers.map((u) => (
                <li key={u._id} className="blocked_user_item">
                  <div className="user_avatar_container">
                    <img src={u.picture} alt={u.name} className="blocked_user_avatar" />
                    <div className="blocked_indicator"></div>
                  </div>
                  <div className="blocked_user_info">
                    <span className="blocked_user_name">{u.name}</span>
                    <span className="blocked_user_username">@{u.username}</span>
                  </div>
                  <button
                    className="unblock_btn"
                    onClick={async () => {
                      if (user && user.token) {
                        try {
                          await axios.post(`${API_URL}/api/block/unblockUser`, { userId: u._id }, {
                            headers: { Authorization: `Bearer ${user.token}` },
                          });
                          setBlockedUsers(blockedUsers.filter(bu => bu._id !== u._id));
                          window.dispatchEvent(new CustomEvent('blockedUsersUpdated'));
                        } catch (err) {
                          alert("Failed to unblock user.");
                        }
                      }
                    }}
                  >
                    <XIcon />
                    <span>Unblock</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Legal Links Section */}
      <div className="settings_section legal_section">
        <div className="section_header">
          <div className="section_icon">
            <FileTextIcon />
          </div>
          <div className="section_title_wrapper">
            <h3 className="section_title">Legal & Policies</h3>
            <p className="section_subtitle">Important documents and policies</p>
          </div>
        </div>
        
        <div className="legal_links_grid">
          <button 
            className="legal_link_card"
            onClick={() => {
              navigate('/privacy');
            }}
          >
            <div className="legal_icon">
              <ShieldIcon />
            </div>
            <div className="legal_content">
              <h4>Privacy Policy</h4>
              <p>How we collect and use your data</p>
            </div>
            <div className="legal_arrow">→</div>
          </button>
          
          <button 
            className="legal_link_card"
            onClick={() => {
              navigate('/terms');
            }}
          >
            <div className="legal_icon">
              <FileTextIcon />
            </div>
            <div className="legal_content">
              <h4>Terms of Service</h4>
              <p>Rules and guidelines for using our platform</p>
            </div>
            <div className="legal_arrow">→</div>
          </button>
          
          {/* <button 
            className="legal_link_card"
            onClick={() => {
              navigate('/cookies');
            }}
          >
            <div className="legal_icon">
              <FileTextIcon />
            </div>
            <div className="legal_content">
              <h4>Cookie Policy</h4>
              <p>How we use cookies and similar technologies</p>
            </div>
            <div className="legal_arrow">→</div>
          </button> */}
        </div>
      </div>
      </div>
    </div>
  </>
  );
}
